export default "__VITE_ASSET__CC5HIF5e__"